// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"c8c39fb9","188":"27904600","320":"f308a972","757":"c5af9188","831":"6a9c3322"}[chunkId] + ".chunk.css";
};